var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-custom-overlay-fields"},_vm._l((_vm.mergedFields),function(field){return _c('collage-custom-overlay-field',{key:field._key,attrs:{"field":field},on:{"change":_vm.valueChanged}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }